<jhi-alert></jhi-alert>
<jhi-bary-card>
  <div body>
    <jhi-bary-table-manager #manager [type]="TABLE_TYPE.TRANSPORT_ORDERS" [service]="transportOrderService">
      <jhi-transports-list
        [transportOrders]="manager.getData()"
        [(pagination)]="manager.pagination"
        (paginationChange)="manager.transition()"
        [tableOptions]="manager.tableOptions"
      ></jhi-transports-list>
    </jhi-bary-table-manager>
  </div>
</jhi-bary-card>
